import { type ServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { commonGuardErrorHandler } from '../../utils/commonGuardErrorHandler';
import { getCurrentLanguage } from '../../utils/getCurrentLanguage';
import { updateGuardsCookie } from '../../utils/updateGuardsCookie';

import type { Guard } from '../../types';

/**
 * 사용자 개인화 되어 있는 언어 설정을 확인하는 가드
 * @description
 * - iam에서 userInfo를 얻어 사용자가 설정한 언어를 확인
 * - 만약 userInfo에 설정한 언어가 없다면 req 헤더에서 거기에도 없다면 ko로 설정
 */
export const determineLanguageGuard: Guard<ServiceAppState> = async ({
  queryClient,
  state,
  context,
}) => {
  try {
    const { language, displayLanguage } = await getCurrentLanguage({ queryClient, state, context });

    const ssrConfig = {
      ...state.ssrConfig,
      ...(state.ssrConfig?._nextI18Next && {
        _nextI18Next: {
          ...state.ssrConfig._nextI18Next,
          initialLocale: language,
        },
      }),
    };

    // language 및 displayLanguage 쿠키의 경우, initial & route 가드 상관없이 업데이트를 실행한다.
    if (language) {
      updateGuardsCookie({ context, state: { language } });
    }
    updateGuardsCookie({ context, state: { displayLanguage } });

    return { ssrConfig, language, displayLanguage, status: STATUS_CODE.OK };
  } catch (error) {
    return commonGuardErrorHandler({
      context,
      state,
      error,
    });
  }
};

determineLanguageGuard.displayName = 'determineLanguageGuard';
